import * as React from "react";
import { SVGProps } from "react";

const SvgExchange = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 213 189"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Exchange_svg__a)">
      <path
        d="M106.3 147.081c29.046 0 52.592-23.546 52.592-52.591 0-29.046-23.546-52.592-52.592-52.592-29.045 0-52.591 23.546-52.591 52.592 0 29.045 23.546 52.591 52.591 52.591Z"
        fill="#00D37E"
      />
      <path
        d="M103.057 125.189v-7.187a26.947 26.947 0 0 1-6.574-1.687 20.07 20.07 0 0 1-6.223-3.769l5.325-8.349a25.541 25.541 0 0 0 5.281 3.111c1.476.598 3.053.91 4.645.921a6.14 6.14 0 0 0 3.879-.964 3.823 3.823 0 0 0 1.161-3.068 3.237 3.237 0 0 0-1.38-2.542 19.921 19.921 0 0 0-3.441-2.192l-4.382-2.19a26.922 26.922 0 0 1-4.383-2.85 14.506 14.506 0 0 1-3.681-3.966 10.058 10.058 0 0 1-1.38-5.39 13.148 13.148 0 0 1 11.065-13.806V63.79h8.064v7.32a17.367 17.367 0 0 1 6.07 2.19 21.906 21.906 0 0 1 4.777 3.879l-6.113 7.034a17.534 17.534 0 0 0-3.704-2.586 8.479 8.479 0 0 0-3.769-.854 6.092 6.092 0 0 0-3.44.789 3.358 3.358 0 0 0-1.162 2.958 2.921 2.921 0 0 0 1.381 2.367 23.486 23.486 0 0 0 3.44 2.016l4.383 2.19a24.33 24.33 0 0 1 4.383 2.806 14.136 14.136 0 0 1 3.44 3.944 10.62 10.62 0 0 1 1.38 5.544 14.81 14.81 0 0 1-2.52 8.984 14.021 14.021 0 0 1-8.436 5.194v7.604l-8.086.021Z"
        fill="#051513"
      />
      <path
        d="M106.3 174.342h-2.192a79.666 79.666 0 0 1-37.922-10.752 79.665 79.665 0 0 1-28.124-27.618 4.386 4.386 0 0 1 7.495-4.558 70.87 70.87 0 0 0 58.683 34.14h1.972a71.279 71.279 0 0 0 50.031-20.699 71.28 71.28 0 0 0 21.055-49.882 4.382 4.382 0 0 1 8.765 0 80.067 80.067 0 0 1-79.763 79.369ZM30.855 98.895a4.383 4.383 0 0 1-4.383-4.382 79.413 79.413 0 0 1 77.616-79.83h2.191a79.987 79.987 0 0 1 70.122 41.438 4.388 4.388 0 0 1-.3 4.968 4.384 4.384 0 0 1-7.37-.739 71.196 71.196 0 0 0-62.364-36.901h-1.95a70.692 70.692 0 0 0-69.114 71.064 4.384 4.384 0 0 1-4.448 4.382Z"
        fill="#000"
      />
      <path
        d="M16.172 98.892a4.383 4.383 0 0 1-4.383-4.382A95.037 95.037 0 0 1 104.11.02a4.38 4.38 0 0 1 4.11 2.615 4.388 4.388 0 0 1-.843 4.798 4.392 4.392 0 0 1-3.07 1.353 86.25 86.25 0 0 0-83.752 85.746 4.383 4.383 0 0 1-4.382 4.36ZM106.3 189.064h-2.192a4.385 4.385 0 0 1 .285-8.765h1.95a85.967 85.967 0 0 0 85.746-85.264 4.382 4.382 0 0 1 8.765 0 94.748 94.748 0 0 1-94.554 94.029Z"
        fill="#000"
      />
      <path
        d="M209.423 99.42H168.73a3.31 3.31 0 0 1-2.52-5.412l20.357-24.28a3.27 3.27 0 0 1 2.52-1.189 3.262 3.262 0 0 1 2.52 1.19l20.357 24.279a3.284 3.284 0 0 1-.759 4.91 3.286 3.286 0 0 1-1.782.502ZM20.97 121.903.744 95.41a3.287 3.287 0 0 1 2.608-5.281h40.451a3.287 3.287 0 0 1 2.608 5.281l-20.226 26.493a3.267 3.267 0 0 1-5.215 0Z"
        fill="#00D37E"
      />
    </g>
    <defs>
      <clipPath id="Exchange_svg__a">
        <path fill="#fff" d="M0 0h212.754v189H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgExchange;
